import { ReactNode, useCallback } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import ShoppingCart from '@view/components/Cards/ShoppingCart';
import { Routes as AppRoutes } from '@view/routes';
import Card from '@molecules/Card';
import Charges from '@view/components/Cards/Charges';
import './style.css';
import PropertyInfo from '@view/components/PropertyInfo';
import { observer } from 'mobx-react';
import { Outlet } from 'react-router-dom';
import { StyledSideComponent, StyledWrapper } from './StyledLayouts';
import { usePageNavigation } from '@view/hooks/usePageNavigation';

type ContentLayoutProps = { children: ReactNode };

const ContentLayout = ({ children }: ContentLayoutProps) => {
  const { isHomePage } = usePageNavigation();

  return (
    <>
      <StyledWrapper>
        {!isHomePage && <Box flex={1}>{children}</Box>}
        <SideComponent />
      </StyledWrapper>
      <Card>
        <PropertyInfo />
      </Card>
    </>
  );
};

const SideComponent = () => {
  const { goTo } = usePageNavigation();

  const asyncGoTo = useCallback(
    (path: string, from: string) => async () => {
      return goTo(path, from);
    },
    [goTo]
  );

  return (
    <Routes>
      <Route path="/" element={<SideComponentLayout />}>
        <Route
          path={AppRoutes.Accommodations}
          element={
            <ShoppingCart
              path={AppRoutes.Accommodations}
              onOk={asyncGoTo(AppRoutes.Addons, AppRoutes.Accommodations)}
            />
          }
        />
        <Route
          path={AppRoutes.Addons}
          element={
            <ShoppingCart
              path={AppRoutes.Addons}
              onOk={asyncGoTo(AppRoutes.AddGuest, AppRoutes.Addons)}
            />
          }
        />
        <Route path={AppRoutes.ReservationConfirmed} element={<Charges />} />
      </Route>
    </Routes>
  );
};

const SideComponentLayout = () => (
  <StyledSideComponent>
    <Outlet />
  </StyledSideComponent>
);

export default observer(ContentLayout);
